import { useState } from "react";
import { BookOpen } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ReferencesPaneProps {
  references: string[] | null;
}

const ReferencesPane = ({ references }: ReferencesPaneProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // Don't render if no references
  if (!references || references.length === 0) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="rounded-full shadow"
          onClick={() => setIsOpen(true)}
        >
          <BookOpen className="w-4 h-4 mr-2" />
          References ({references.length})
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <BookOpen className="w-5 h-5" />
            References ({references.length})
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 pr-2 space-y-3 overflow-y-auto">
          {references.map((url, index) => (
            <div key={index} className="p-3 rounded-md bg-gray-50">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 underline break-all hover:text-blue-800"
                title={url}
              >
                {url}
              </a>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReferencesPane;
